<template>
  <div class="animated fadeIn">
    <global-table
      :table-data="employeeSourceSalaryList"
      :loading="loadingParam"
      :per-page="10"
      :bordered="true"
      :table-detail="tableDetail"
      :hover="true"
      :striped="false"
      :fields="fields"
      :row-edit="employeeSourceSalaryForm"
      :redirect-detail="false"
      :show-add-button="true"
      :remove-button="true"
      caption="<i class='fa fa-align-justify'></i> Sumber Gaji Karyawan"
      addButton="Tambah Sumber"
      @resetForm="resetForm"
      @editForm="editForm"
      @removeForm="removeForm"
    ></global-table>

    <b-modal
      ref="myModalRef"
      id="addModals"
      header-border-variant="no-border text-center"
      footer-border-variant="no-border"
      footer-bg-variant="light"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      size="lg"
    >
      <div slot="modal-header" class="text-center">
        <h3 class="text-center">Tambah Sumber Gaji Karyawan</h3>
      </div>

      <b-form id="employeeSourceSalaryForm" validated novalidate>
        <div v-if="!loadingSubmitModal">
          <b-row>
            <b-col sm="4">
              <b-form-group label-for="company" label="Nama Perusahaan">
                <model-select
                  id="company"
                  :options="listCompany"
                  v-model="$v.employeeSourceSalaryForm.company.$model"
                  :isError="$v.employeeSourceSalaryForm.company.$invalid"
                  required
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="employeeSourceSalaryForm.company === null"
                  class="invalid-feedback-custom"
                >
                  Nama barang harus di pilih.
                </div>
              </b-form-group>
            </b-col>

            <b-col sm="4">
              <b-form-group label-for="name" label="Salary">
                <b-form-input
                  id="name"
                  type="number"
                  v-model="$v.employeeSourceSalaryForm.salary.$model"
                  :state="!$v.employeeSourceSalaryForm.salary.$invalid"
                  required
                  placeholder="Salary"
                ></b-form-input>
                <b-form-invalid-feedback
                  >Gaji karyawan harus di isi.</b-form-invalid-feedback
                >
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div v-else>
          <loading></loading>
        </div>
      </b-form>

      <div slot="modal-footer" class="float-right">
        <div v-if="!loadingSubmitModal">
          <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
            <i class="fa fa-undo"></i> Back </b-button
          >&nbsp;
          <b-button
            type="button"
            size="sm"
            variant="primary"
            @click="saveProcess"
            :disabled="$v.employeeSourceSalaryForm.$invalid"
          >
            <i class="fa fa-save"></i> Save
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "@/templates/Table.vue";
import _interfaces from "@/templates/_interfaces.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import { ModelSelect, MultiSelect } from "vue-search-select";
import loading from "@/templates/Loading.vue";
export default {
  name: "employee-source-salary",
  components: { loading, ModelSelect, MultiSelect, loading, globalTable },
  data() {
    return {
      employeeSourceSalaryForm: _interfaces.employee_source_salary,
      employeeSourceSalaryList: [],
      employee_id: '',
      isEdit: false,
      fields: [
        { key: "company_name", label: "Nama PT", class: "width-250" },
        {
          key: "salary",
          label: "Jumlah",
          class: "width-250",
          sortable: true,
        },
        { key: "action", class: "width-50 text-center" },
      ],
      loadingSubmitModal: false,
    };
  },
  props: {
    isDisable: {
      type: Boolean,
      default: true,
    },
    nik: {
      type: String,
      default: "",
    },
    loadingParam: {
      type: Boolean,
      default: true,
    },
    childAddButton: {
      type: Boolean,
      default: false,
    },
    tableDetail: {
      type: Boolean,
      default: true,
    },
    listCompany: {
      type: [Array],
      default: () => [],
    },
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  validations: {
    employeeSourceSalaryForm: {
      nik: {},
      company: { required },
      salary: { required },
    },
  },
  methods: {
    init: function () {
      this.resetForm();
      let route = this.$route.path.split("/");
      this.employee_id = route[4];
      this.getEmployeeSourceSalary(route[4]);
    },

    getEmployeeSourceSalary: function (id) {
      this.axios
        .get("web/employee/source-salary/" + id)
        .then((response) => {
          this.employeeSourceSalaryList = response.data.data;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    editForm: function (e) {
      this.isEdit = true;
      this.employeeSourceSalaryForm = e;
    },
    resetForm: function () {
      for (var a in _interfaces.employee_source_salary) {
        _interfaces.employee_source_salary[a] = null;
      }
      this.employeeSourceSalaryForm = _interfaces.employee_source_salary;
    },
    removeForm: function (a) {
      if (confirm("Apakah anda ingin menghapus informasi sumber gaji ?")) {
        this.loadingSubmitModal = true;
        this.axios
          .delete("web/employee/source-salary/"+ a.id)
          .then((response) => {
            if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Hapus Sumber Gaji Berhasil",
                message: response.data.message,
              });
            } else {
              this.showErrorNotification({
                title: "Hapus Sumber Gaji Gagal",
                message: response.data.message,
              });
            }
          })
          .catch((error) => {
            this.expired(error);
          })
          .finally(() => {
            this.loadingSubmitModal = false;
            this.cancelAdd();
            this.init();
          });
      }
      console.log(a);
    },
    cancelAdd: function () {
      this.isEdit = false;
      this.$refs.myModalRef.hide();
      this.init();
    },
    saveProcess: function (evt) {
      evt.preventDefault();
      if (this.isEdit) {
        if (confirm("Apakah anda ingin mengubah informasi sumber gaji ?")) {
          this.loadingSubmitModal = true;
          this.axios
            .put(
              "web/employee/edit-source-salary/",
              this.employeeSourceSalaryForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Ubah Sumber Gaji Berhasil",
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: "Ubah Sumber Gaji Gagal",
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      } else {
        if (confirm("Apakah anda ingin menambahkan informasi sumber gaji ?")) {
          this.loadingSubmitModal = true;
          this.employeeSourceSalaryForm.employee_id = this.employee_id;
          this.axios
            .post(
              "web/employee/add-source-salary/",
              this.employeeSourceSalaryForm
            )
            .then((response) => {
              if (response.data.status === 2000) {
                this.showInfoNotification({
                  title: "Tambah Sumber Gaji Berhasil",
                  message: response.data.message,
                });
              } else {
                this.showErrorNotification({
                  title: "Tambah Sumber Gaji Gagal",
                  message: response.data.message,
                });
              }
            })
            .catch((error) => {
              this.expired(error);
            })
            .finally(() => {
              this.loadingSubmitModal = false;
              this.cancelAdd();
              this.init();
            });
        }
      }
    },
    expired: function (error) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: "Master Divisi Karyawan",
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
